import React from 'react';

interface ResponsiveCardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  maxHeight?: string;
}

const ResponsiveCard: React.FC<ResponsiveCardProps> = ({ 
  children, 
  className = '', 
  style = {},
  maxHeight = '85vh'
}) => {
  return (
    <div
      className={`
        responsive-card
        w-full max-w-full mx-0
        h-screen sm:h-auto
        sm:max-w-[500px] sm:mx-4
        md:max-w-[600px]
        lg:max-w-[500px] lg:mx-auto
        rounded-3xl shadow-lg border border-gray-200
        flex flex-col relative
        overflow-hidden
        ${className}
      `}
      style={{
        backgroundColor: '#fafafa',
        maxHeight,
        ...style
      }}
    >
      {children}
    </div>
  );
};

export default ResponsiveCard; 